module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAOJJREFUOE/tk8FKQlEURdeGQMJCEGrYpN9oKmFg+Cd+h7/SJEgI6S/8CikijEIIhS0HrvB4Pe/rpUPv8N59Fmfvc6448NGBeRyB+yf6K0PbHWAlaZnD2z4FWpIWRV0VcAzcAHeSPqugts+BCTCTNKoDbsWhG0j6KhbYbgNPwBnQl/SRBcZjsv0M/AD3kr7Tfdh8BC6AW0nvZQc799B2F5gCYXsIrIEH4CrB3qriyC627egkoFEcQ7pOsNddA6v9KbYvgRfgBOhJmuemXwssZKryijS2/J81/1OHTcBHYJO0qrUbokhAFco4m2IAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ico_down.png
// module id = o+hR
// module chunks = 0